export const EMAIL_EVENTS_ORDER_BY_ID = {
  1: 0,
  2: 1,
  3: 2,
  5: 3,
  6: 4,
  7: 5,
  13: 9,
  14: 10,
  15: 11,
  16: 12,
  17: 13,
  18: 14,
  23: 15,
  32: 6,
  33: 7,
  34: 8,
};
